import FadeDiv from "./common/FadeDiv";
import React from "react";
import clsx from "clsx";

interface ChooseGailCardProps {
  percentage: number;
  title: string;
}

const ChooseGailCard: React.FC<ChooseGailCardProps> = ({
  percentage,
  title,
}) => {
  return (
    <div
      className={clsx(
        "py-2",
        "md:py-4",
        "px-4",
        "lg:px-8",
        "flex",
        "flex-col",
        "flex-grow",
        "bg-white"
      )}
    >
      <FadeDiv
        className={clsx("flex", "flex-col", "flex-grow", "justify-between")}
      >
        <div>
          <h2 className={clsx("text-7xl", "font-medium", "mt-8", "leading-6")}>
            {percentage}
            <span className={clsx("text-5xl", "font-normal")}>%</span>
          </h2>
          <h3 className={clsx("text-xl", "font-medium", "leading-6", "h-12")}>
            {title}
          </h3>
        </div>
      </FadeDiv>
    </div>
  );
};

export default ChooseGailCard;
